// extracted by mini-css-extract-plugin
export default {"inputGroup":"price-input_inputGroup__3IsCA","invalid":"price-input_invalid__s5Gut"};